import { TextField, Autocomplete } from "@mui/material";

export const OldSelectField = ({ field, options, onChange }) => {
    const { name, value, label, required, disabled } = field;
    const autocompleteProps = {
      options,
      getOptionLabel: (option) => {
        return option.label ?? option;
      },
      isOptionEqualToValue: (option, value) => {
        if (option.value) {
          return option.label === value || option.value === value;
        } else {
          return option === value;
        }
      },
      name,
      value: value === null ? value : value.label ? value.label : value,
      onChange,
      sx: { "&.MuiAutocomplete-root .MuiOutlinedInput-root": { padding: "4.5px" } },
      renderInput: (params) => (
        <TextField
          {...params}
          style={{marginBottom: "12px"}}
          label={label}
          name={name}
          {...(required && { required })}
          {...(disabled && { disabled })}
        />
      ),
    };
    return <Autocomplete {...autocompleteProps} />;
  }